import getCookie from './lib/GetCookie';

const blackWhite = (button: HTMLElement) => {
  const spans = button.querySelectorAll('span');
  let color = true;

  const switchMode = () => {
    color = !color;
    document.cookie = `mode=${color}`;
    document.body.classList.toggle('black-white');
    if (spans.length > 0) {
      [...spans].forEach((span) => {
        span.classList.toggle('d-none');
      });
    }
  };

  if (getCookie('mode') === 'false') {
    switchMode();
  }

  button.addEventListener('click', () => {
    switchMode();
  });
};

export default blackWhite;
